module.exports = __webpack_public_path__ + "static/attribution-fraud-463c8083a8852e745c62054f9a9cc6d5.gif";